import { fetchJsonWithAuthJWTToken } from "ra-data-django-rest-framework"

import endpoints from "api/endpoints"

class SiteMailoutsAPI {
  mailoutEmails() {
    return fetchJsonWithAuthJWTToken(endpoints.siteMailoutEmails()).then(
      ({ json }) => json
    )
  }

  sendMailout(data) {
    return fetchJsonWithAuthJWTToken(endpoints.sendSiteMailout(), {
      method: "post",
      body: JSON.stringify(data),
    }).then(({ json }) => json)
  }
}

export default new SiteMailoutsAPI()
